import { createStore } from '@direct-frontend/modules-store';

export const store = createStore('entities/constructor');
